import { useState } from 'react'
import { PointsExpiration } from "./PointsExpiration";

const PointsExpirationList = ({ point_types_field, value }) => {

  const [ points, setPoints ] = useState([])

  tangibleFields.event('valueChange', field => {

    // when rendered from react observed combo-box returns value as an array of objects - when rendered from PHP returns comma separated string 🧐
    if (field.name !== point_types_field) return;

    let values = []
    let isArray = false;
    let items = []

    if (Object.keys(field.value).length === 0 && !Array.isArray(field.value) || field.value === '') return

    if (Array.isArray(field.value)) {
      for (const val of field.value) {
        values.push({id: val.value, label: val.label})
      }
      isArray = true
    } else {
      values = field.value.split(',')
    }

    for (const value of values) {
      if (isArray) {
        items.push(value)
      } else {
        items.push({id: value, label: field.props.choices[parseInt(value)]})
      }
    }

    setPoints([...items])

  })

  return (
    <>{ points.map( point => <PointsExpiration pointType={point} key={JSON.stringify(point)} pointExpiration={value[point.id] ?? []}/> ) }</>
  )
}

export { PointsExpirationList }
